<a class="notification-link" (click)="downloadFile()">{{
    'Dashboard::ClickHereToDownloadAqmEvaluatorQuestionBasedReport' | abpLocalization
  }}</a>
